//const urldata = 'http://localhost:4000/api/'
const urldata = 'https://aceyindia.com/api/'
// const urldata = 'http://67.222.25.150:4000/api'

export default urldata
